import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, throwError} from 'rxjs';
import {UserCollectionDto, UserCollectionDtoInterface} from './dto/user-collection-dto';
import {SearchList} from '../../../search/search-list/search-list';
import {FilterUserCollectionDto} from './dto/filter-user-collection-dto';
import {BaseUserTableService} from '../base-user-table.service';
import {MessageService} from '../../../messages/message.service';

@Injectable({
  providedIn: 'root'
})
export class UserCollectionsService extends BaseUserTableService<UserCollectionDtoInterface, FilterUserCollectionDto> {

  favourites = new BehaviorSubject<String[]>([]);
  favouritesCheck = new BehaviorSubject<SearchList>(null);
  private readonly baseUrl = 'portalApiUrl/omnis/user/collection';

  constructor(protected http: HttpClient) {
    super(http);
  }

  protected normalizeToQueryParams(filterDto: FilterUserCollectionDto): {
    [param: string]: string | string[];
  }{
    if (!filterDto.name) {
      filterDto.name = '';
    }
    if (!filterDto.desc) {
      filterDto.desc = '';
    }
    if (!filterDto.itemsCountFrom) {
      filterDto.itemsCountFrom = '';
    }
    if (!filterDto.itemsCountTo) {
      filterDto.itemsCountTo = '';
    }
    if (!filterDto.creationFrom) {
      filterDto.creationFrom = '';
    }
    if (!filterDto.creationTo) {
      filterDto.creationTo = '';
    }
    return {
      name: filterDto.name, desc: filterDto.desc, itemCountFrom: filterDto.itemsCountFrom, itemCountTo: filterDto.itemsCountTo,
      creationFrom: filterDto.creationFrom, creationTo: filterDto.creationTo
    };
  }

  async handleSaveUserCollection(value: UserCollectionDtoInterface, token: string,
                                 messageService: MessageService): Promise<UserCollectionDtoInterface> {
    try {
      const saveResult = await this.update(value, token).toPromise();
      if (saveResult){
        value.id = saveResult+'';
        messageService.successMessage('UserCollection.persisted', 'UserCollection.persisted.desc');
        return value;
      }
    }catch (error1) {
      console.log(error1);
    }
    messageService.errorMessage('UserCollection.persisted.error', 'UserCollection.persisted.desc.error');
    return null;
  }

  canRememberLast(filterDto: FilterUserCollectionDto): boolean {
    return filterDto.name === '' && filterDto.desc === '';
  }

  getBaseUrl(): string {
    return this.baseUrl;
  }

  public findUserCollectionItemsIds(id: string, token: string){
    return this.http.get<string[]>(this.baseUrl + `/items/${id}`,{headers: this.createHeaders(token)});
  }
  public getFavourites(itemsToCheck: string[], token: string) {
    return this.http.get<string[]>(this.baseUrl + `/item/exists/${itemsToCheck.join(',')}`,
      {headers: this.createHeaders(token)});
  }

  public async insertUserCollectionItemAndCreate(name: string, targetId: string, targetType: string, token: string): Promise<number> {
    const userCollectionId = await this.update(UserCollectionDto.create(name), token).toPromise();
    if (userCollectionId) {
      return this.insertUserCollectionItem(userCollectionId + '', targetId, targetType, token);
    } else {
      return throwError('Can\'t create user collection').toPromise();
    }
  }

  public async insertUserCollectionItem(id: string, targetId: string, targetType: string, token: string): Promise<number> {
    return await this.http.post<number>(this.baseUrl + `/item/${id}/${targetId}/${targetType}`,
      '', {headers: this.createHeaders(token)}).toPromise();
  }

  public async deleteUserCollectionItem(targetId: string, targetType: string, collectionId, token: string): Promise<boolean>{
    return await this.http.delete<boolean>(this.baseUrl + `/item/${targetId}/${targetType}/${collectionId}`,
      {headers: this.createHeaders(token)}).toPromise();
  }

  public getCollectionWithCertainItemId(itemId, token) {
    return this.http.get<string[]>(this.baseUrl + `/items/belongingness/${itemId}`,
      {headers: this.createHeaders(token)});
  }

  public getPlainUserCollection(token) {
    return this.http.get<string[]>(this.baseUrl + `/plain`,
      {headers: this.createHeaders(token)});
  }

}
